export default {
  // Calendar-specific: adaptive day selection highlight.
  selectedDay: ['--blue .12', '--blue .18']
}
